<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row style="margin-bottom:10px;">
      <a-col :span="8">
        <a-button type="primary" @click="createEvent(0)">添加供应商</a-button>
      </a-col>
      <a-col :span="8" :offset="8" class="right-box">
        <a-button @click="goRulesPage">同步规则</a-button>
        <a-button type="primary" style="margin-left:30px;" @click="accountSetting">账号设置</a-button>
      </a-col>
    </a-row>
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <div slot="action" slot-scope="data">
        <a @click="createEvent(data.record.id)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <span>
        <a v-if="data.record.directStatus == 0" @click="handleEvent(data.record.id,1)">启用</a>
        <a v-else @click="handleEvent(data.record.id,0)">禁用</a>
      </span>
      </div>
    </search-page-view>
    <a-modal title="添加供应商" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="供应商名称" prop="pftSupplierName">
          <a-input v-model.trim="ruleForm.pftSupplierName" placeholder="仅用于区分标识数据来源，6个字内" :maxLength="6"/>
        </a-form-model-item>
        <a-form-model-item label="供应商 id(UUaid)" prop="pftSupplierId">
          <a-input v-model.trim="ruleForm.pftSupplierId" placeholder="请输入供应商 id(UUaid)" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item label="支付方式" prop="pftSupplierPayMode">
          <a-radio-group name="radioGroup" v-model="ruleForm.pftSupplierPayMode">
            <a-radio :value="0">账户余额</a-radio>
            <a-radio :value="2">供应商授信额度</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit('ruleForm')" :loading="submitLoading">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal title="账号设置" :visible="popupVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="dataForm" ref="dataForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="账号(ac)" prop="accountAc">
          <a-input v-model.trim="dataForm.accountAc" placeholder="请输入账号" :maxLength="20"/>
        </a-form-model-item>
        <a-form-model-item label="密钥(pw)" prop="accountPw">
          <a-input v-model.trim="dataForm.accountPw" placeholder="请输入密钥" :maxLength="100"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit('dataForm')" :loading="submitLoading">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'SyncTicketOrder',
  components: {},
  data() {
    return {
      submitLoading: false,
      dialogVisible: false,
      popupVisible: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        id: '',// 票付通直连供应商id ,
        pftSupplierId: '',// 票付通供应商Id（UUaid） ,
        pftSupplierName: '',// 票付通供应商名称 ,
        pftSupplierPayMode: undefined,// 0-账户余额，2-供应商授信额度 ,
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId
      },
      dataForm: {
        accountAc: '',// 票付通账号 ,
        accountPw: '',// 票付通密码 ,
        id: '',// 票付通账号id ,
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId
      },
      rules: {
        pftSupplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        pftSupplierId: [
          { required: true, message: '请输入供应商 id(UUaid)', trigger: 'blur' }
        ],
        pftSupplierPayMode: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        accountAc: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        accountPw: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'pftSupplierName'
        },
        {
          title: '供应商 id(UUaid)',
          dataIndex: 'pftSupplierId'
        },
        {
          title: '结算方式',
          dataIndex: 'pftSupplierPayModeStr'
        },
        {
          title: '状态',
          dataIndex: 'directStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 7 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 17 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SyncTicketPro', title: '同步商品' },
      { name: 'SyncTicketOrder', title: '订单直连' },
      { name: 'RelAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('pft/pftDirectSupplierList', params)
    },
    handleCancel() {
      this.dialogVisible = false
      this.popupVisible = false
    },
    handleSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (form == 'dataForm') {
            this.getLogUtils().logWithTag('账号设置', form)
            this.submitAccountData()
          } else {
            this.getLogUtils().logWithTag('添加供应商', form)
            this.submitSupplierData()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 新增、编辑供应商信息
    submitSupplierData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('pft/editPftDirectSupplier', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitSupplierData', res)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 账号设置
    submitAccountData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('pft/editPftDirectAccount', this.dataForm).then(res => {
        this.getLogUtils().logWithTag('submitAccountData', res)
        this.$message.success('保存成功')
        this.popupVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 回显供应商信息
    createEvent(id) {
      this.dialogVisible = true
      if (id != 0) {
        this.getHttpServices().getServerApiService().get('pft/getPftDirectSupplier?id=' + id).then(res => {
          this.ruleForm = res
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          id: '',// 票付通直连供应商id ,
          pftSupplierId: '',// 票付通供应商Id（UUaid） ,
          pftSupplierName: '',// 票付通供应商名称 ,
          pftSupplierPayMode: undefined,// 0-账户余额，2-供应商授信额度 ,
          merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
          platformId: this.getPlatformConfig().platformId
        }
      }
    },
    // 账号设置
    accountSetting() {
      this.popupVisible = true
      this.getHttpServices().getServerApiService().post('pft/getPftDirectAccount', {
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res && res.accountAc) {
          this.dataForm = res
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 操作
    handleEvent(id, status) {
      let text = status == 1 ? '启用' : '禁用'
      let that = this
      this.$confirm({
        title: '此操作将' + text + '该供应商?，是否继续',
        onOk() {
          that.getUpdateStatus(id)
        },
        onCancel() {
          that.$message.info('已取消')
        }
      })
    },
    // 查询状态
    getUpdateStatus(id) {
      this.getHttpServices().getServerApiService().post('pft/updatePftDirectSupplierStatus?id=' + id, {}).then(res => {
        this.$message.success('操作成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goRulesPage() {
      this.$router.push({
        name: 'SyncRules',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.right-box {
  text-align: right;
}
</style>